import styled, { css } from 'styled-components';
import colors from 'Styles/colors';

const TONE_BACKGROUND = {
  online: colors.blueCerulean,
  offline: colors.blueGrey,
  unsupported: colors.orange2
};

const Wrapper = styled.div`
  flex: 0 0 auto;
  min-width: 69px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
  height: 25px;
  color: ${colors.white};
  ${({ $tone }) => css`
    background: ${TONE_BACKGROUND[$tone] || TONE_BACKGROUND.online};
  `}
`;

export default Wrapper;
